/*
defines the data structure for storing local images
*/

import ImageNode from './imageNode';
import {colorPrintMetaData} from '../utilities/utilities';

/**
 * represents an image node for external/local images (not APIs)
 */
export default class LocalImageNode extends ImageNode {
    /**
     * makes a new image node with the given id and information about the image
     * @param {number} id id of this new node
     * @param {Object} image object containing url, width, height of image
     */
    constructor(id, image) {
        super(id, function() {}, {}, {});
        this.imageObj = image;
        this.type = 'image';
        if (_.isEmpty(image)) console.error('problem creating localimagenode: empty image object given');
    }

    /**
     * gets the data for this node and associates it
     */
    getNewNodeData() {
        this.updateCallback();
    }

    /**
     * gets the image object for this node
     */
    get image() {
        return this.imageObj;
    }
    /**
     * gets the title of the image
     */
    get title() {
        return this.imageObj.title;
    }

    /**
     * get all of the data about this node
     */
    get metadata() {
        return colorPrintMetaData(this.imageObj);
    }

    /**
     * checks if the API returned anything
     */
    isEmpty() {
        return _.isEmpty(this.imageObj);
    }
}
